import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { send } from "../../app/appSlice";
import { AppThunkApi, RootState } from "../../app/store";
import { firstPage, Page } from "../../models/page";
import {
  ExceptionDetail,
  ExceptionPage,
  ExceptionParams,
} from "../../services/exception";
interface exceptionState {
  exceptionListPage: Page;
  exceptionDetail?: any;
}

const initialState: exceptionState = {
  exceptionListPage: firstPage(),
};

// 分页
export const getExceptionListAsync = createAsyncThunk<
  void,
  ExceptionParams,
  AppThunkApi
>("ExceptionList/page", async (params, api) => {
  return send(ExceptionPage(params), api);
});

// 详情
export const getExceptionDetailAsync = createAsyncThunk<
  void,
  number,
  AppThunkApi
>("ExceptionDetail/deteil", async (params, api) => {
  return send(ExceptionDetail(params), api);
});

export const exceptionListSlice = createSlice({
  name: "ExceptionListStation",
  initialState,
  reducers: {
    setExceptionList(state, action) {
      state.exceptionListPage = action.payload;
    },
    setExceptionDetail(state, action) {
      state.exceptionDetail = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getExceptionListAsync.fulfilled, (state, action: any) => {
      state.exceptionListPage = action.payload;
    });
    builder.addCase(getExceptionDetailAsync.fulfilled, (state, action: any) => {
      state.exceptionDetail = action.payload;
    });
  },
});

export const { setExceptionList, setExceptionDetail } =
  exceptionListSlice.actions;

export const selectExceptionList = (state: RootState): Page =>
  state.exception.exceptionListPage;

export const selectExceptionDetail = (state: RootState) =>
  state.exception.exceptionDetail;

export default exceptionListSlice.reducer;
